import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { useFirebaseAuth } from '../../../global/FirebaseProvider/FirebaseProvider';
import { ROUTE_MANAGE_MEMBERSHIP, ROUTE_MY_ACCOUNT } from '../../config/routes';
import { isTrashieMembershipPath } from '../../utils/routes';

const TrashieMembershipContainer = ({ children }) => {
  const { isLoading, isSignedIn, userData } = useFirebaseAuth();
  const history = useHistory();
  const { pathname } = useLocation();

  useEffect(() => {
    if (!isLoading && isSignedIn && userData?.email && isTrashieMembershipPath(pathname)) {
      // Manage Membership stays reachable without an entitled membership: it is
      // where a lapsed member renews. The view itself sends a never-member away.
      if (!userData?.activeSubscription && pathname !== ROUTE_MANAGE_MEMBERSHIP) {
        history.push(ROUTE_MY_ACCOUNT);
      }
    }
  }, [isLoading, isSignedIn, userData, pathname]);

  if (isLoading || !isSignedIn || !isTrashieMembershipPath(pathname)) {
    return null;
  }

  return children;
};

export default TrashieMembershipContainer;
